export default __webpack_public_path__ + "static/media/following.0dae7ab5.svg";